<template>
  <el-tabs v-model="page" type="border-card" class="pagetabs" :closable='pages.length>1' @tab-click="handleClick" @tab-remove="removeTab">
    <el-tab-pane v-for="item in pages" :key="item.path" :name="item.path" :label="item.label">
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'Pagetabs',
	computed: mapGetters({
		pages: 'layout/pages',
	}),
	props: {
		index: {
			type: Boolean,
		},
	},
	data() {
		return {
			page: '',
		}
	},
	methods: {
		init() {
			let flog = this.pages.filter((page) => page.path == this.$route.path)
			if (!flog.length) {
				this.$store.commit('layout/addPage', { path: this.$route.path, label: this.$route.meta.title })
			}
			this.page = this.$route.path
		},
		handleClick(tab) {
			this.$router.push(tab.name)
		},
		removeTab(name) {
			this.$store.commit('layout/removePageToName', name)
			if (this.$route.path == name) {
				this.$router.push(this.pages[this.pages.length - 1].path)
			}
		},
	},
	watch: {
		$route: {
			handler() {
				this.init()
			},
			immediate: true,
		},
	},
}
</script>

<style scoped>
.pagetabs {
	height: 40px;
	border: 0;
	box-shadow: 0 0 transparent;
}
.pagetabs /deep/ .el-tabs__content {
	display: none;
}
</style>
